import Image from "next/image"
import { useContext } from "react"
import { isMobileContext } from "../../contexts/isMobileContext"
import { BASE_URL } from "../../utils/FetchData"
import FadeIn from "../Animations/FadeIn"
import { Parallax } from "react-parallax";
const OurStory = ({ ourStoryData }) => {
    const { isMobile } = useContext(isMobileContext)
    return (
        <>
            <FadeIn customClass="our-story-section our-story" id="our-story">
                <div className="header light _eleX">
                    <h2>{ourStoryData?.header}</h2>
                </div>
                <div className="description _eleX">
                    <p>{ourStoryData?.description1}</p>
                </div>
            </FadeIn>
            <FadeIn customClass={'who-we-are-story-img'}>
                <div className="details _eleX">
                    <h3 className="light">{ourStoryData?.title}</h3>
                    {!isMobile && <p>{ourStoryData?.description2}</p>}
                </div>
                <div className="img-container">
                    {ourStoryData && <Image
                        src={`${BASE_URL}${isMobile ? ourStoryData?.img_mobile.data.attributes?.url : ourStoryData?.img_desktop.data[0].attributes?.url}`}
                        layout="fill"
                        objectFit="cover"
                        alt={ourStoryData?.img_desktop.data[0].attributes?.name}
                    />}
                </div>
                {isMobile &&
                    <div className="details _eleX">
                        <p>{ourStoryData?.description2}</p>
                    </div>
                }
            </FadeIn>
        </>

    )
}

export default OurStory
